<template>
    <v-col
        :cols="width"
        class="d-flex justify-space-between"
    >
        <v-label class="justify-start">
            <div v-html="item.props.label"></div>
        </v-label>

        <template v-if="item.props.tooltip">
            <v-tooltip
                top
                max-width="620"
            >
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on"  class="justify-end">mdi-information</v-icon>
                </template>
                <span v-html="item.props.tooltip"></span>
            </v-tooltip>
        </template>
    </v-col>
</template>
<script>
    export default {
        name: 'Label',
        props: {
            item: {
                type: Object,
                default: () => ({
                    props: {}
                })
            },
            width: {
                type: [String, Number]
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/label.vue